module.exports = __webpack_public_path__ + "img/existing-templates.23557a8d.png";